import { render, staticRenderFns } from "./Rentabilidade.vue?vue&type=template&id=7fc33710&scoped=true&"
import script from "./Rentabilidade.vue?vue&type=script&lang=js&"
export * from "./Rentabilidade.vue?vue&type=script&lang=js&"
import style0 from "./Rentabilidade.vue?vue&type=style&index=0&id=7fc33710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc33710",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fc33710')) {
      api.createRecord('7fc33710', component.options)
    } else {
      api.reload('7fc33710', component.options)
    }
    module.hot.accept("./Rentabilidade.vue?vue&type=template&id=7fc33710&scoped=true&", function () {
      api.rerender('7fc33710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Rentabilidade/Rentabilidade.vue"
export default component.exports